<template>
  <l-layout :layout="['xs12']">
    <l-data-table
    :headers="header"
    ref="passRuleList"
    :get-data-func="getRuleList"
    :filter-items="filter">
      <template slot="row-action" slot-scope="{item,index}">
        <td @click.stop class="px-0 mx-0 text-xs-center">
          <v-menu  left>
            <v-btn slot="activator" icon small>
              <v-icon  small>$vuetify.icons.more</v-icon>
            </v-btn>
            <v-list dense>
              <v-list-tile @click="openSetRuleDialog('edit',item, index)" :disabled="item.status!=='1'">
                <v-list-tile-avatar>
                  <v-icon small>{{$vuetify.icons.edit}}</v-icon>
                </v-list-tile-avatar>
                <v-list-tile-title class="pr-1">
                  编辑
                </v-list-tile-title>
              </v-list-tile>
              <v-list-tile @click="deletePassRule(item)" :disabled="item.status!=='1'">
                <v-list-tile-avatar>
                  <v-icon small>{{$vuetify.icons.delete}}</v-icon>
                </v-list-tile-avatar>
                <v-list-tile-title class="pr-1">
                  删除
                </v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
        </td>
      </template>
    </l-data-table>
    <v-dialog max-width="900px" persistent scrollable v-model="passRuleDialog.activate">
      <set-pass-rule-content
        :authority="authority"
        :params="{index: passRuleDialog.index, type: authority.name}"
        :rule="passRuleDialog.item"
        :status="passRuleDialog.status"
        @cancel="closeSetRuleDialog"
        @save="setPassRule($event.newItem)"
        ref="ruleContent"
        v-if="passRuleDialog.activate"
      >
        <template slot="append" slot-scope="{newItem, status}">
          <v-subheader class="mx-0">车辆信息</v-subheader>
          <v-layout wrap class="mb-4">
            <v-flex xs12>
              <l-plate-picker
                :disabled="status === 'edit'"
                label="车辆号牌"
                prepend-icon="$vuetify.icons.car"
                v-model="newItem.groupId"
              ></l-plate-picker>
            </v-flex>
          </v-layout>
        </template>
      </set-pass-rule-content>
    </v-dialog>
    <l-fixed-btn
      @click="openSetRuleDialog('new', null, 0)"
      icon="$vuetify.icons.add"
    ></l-fixed-btn>
  </l-layout>
</template>

<script>
    import LDataTable from "../../../ladmin/components/LDataTable/LDataTable";
    import SetPassRuleContent from '../../../components/SetPassRuleContent'
    import LPlatePicker from '../../../components/LPlatePicker'
    let statusMap = {
      '1':"有效",
      '-1':'无效'
    }
    export default {
      name: "aloneRuleList",
      components: {LDataTable,SetPassRuleContent,LPlatePicker},
      data(){
          return {
            header:[
              {text:'车辆号牌',value:'groupId',sortable:false,align:'left'},
              {text:'开始时间',value:'startDatetime',sortable:true,align:'left'},
              {text:'结束时间',value:'endDatetime',sortable:true,align:'left'},
              {text:'规则类型',value:'ruleType',sortable:false,align:'left',f:(v)=>(v==='sectional')?"时段型":"周期型"},
              {text:'规则状态',value:'status',sortable:false,align:'left',f:(v)=>(v==='1')?"有效":"无效"},
              {text:'',value:'',sortable:false,align:'left'}
            ],
            filter: [
              {
                prependIcon: '$vuetify.icons.edit',
                key: 'status',
                value: '{"r_h_status":"1"}',
                label: '是否有效',
                type: 'select',
                layout: ['xs12', 'sm4'],
                items: [
                  {
                    value: '',
                    text: '全部'
                  },
                  {
                    value: '{"r_h_status":"1"}',
                    text: '有效'
                  },
                  {
                    value: '{"r_h_status":"-1"}',
                    text: '失效'
                  }],
              },
            ],
            passRuleDialog: {
              activate: false,
              status: 'new',
              item: {},
              index: 0,
            },
          }
      },
      computed:{
        authority(){
          return this.$store.state.reservation.adminAuth
        }
      },
      methods:{
        async getRuleList ({pagination, sortStack, filterItems = [], search}) {
          let filter = [
            ...this.filter,
            {key:'ownerType',value:'object'}
          ]
          let {items,amount} = await this.$store.dispatch('passControl/getRules',{pagination, sortStack, filter:filter, search:{key:"ownerId",value:search}})
          return {items:items,amount:amount}
        },
        openSetRuleDialog (status, item, index) {
          this.passRuleDialog = {
            activate: true,
            status: status,
            item: item || undefined,
            index: index,
          }
        },
        async setPassRule (rule) {
          console.log(rule)
          try {
            await this.$store.dispatch('passControl/setRule', rule)
            this.closeSetRuleDialog()
            this.$L.alert('success', `操作成功`)
            this.$refs.passRuleList.refresh()
          }
          catch (e) {
            this.$L.alert('error', e.message)
          }
        },
        closeSetRuleDialog () {
          this.passRuleDialog = {
            activate: false,
            status: 'new',
            item: undefined,
            index: 0,

          }
        },
        async deletePassRule (rule) {
          let {res, close} = await this.$L.confirm({
            title: '确认删除',
            text: '确认删除该规则？'
          })
          if (res) {
            try {
              await this.$store.dispatch('reservation/deleteRules', [rule])
              this.$L.alert('success', '删除成功')
              this.$refs.passRuleList.refresh()
            }
            catch (e) {
              this.$L.alert('error', e.message)
            }
          }
          close()
        },
      }
    }
</script>

<style scoped>

</style>
